import { useShallow } from 'zustand/react/shallow'
import { ResetIcon } from '@/components/icons/ResetIcon'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

import { ControlButton } from '../ControlButton'
import { useCADQuery } from '@/services/queries/cads'
import { useCADPageStore, ExplosionsState } from '@/state'

export const ResetExplosionsButton = () => {
  const explosions = useCADPageStore((state) => state.explosions)
  const setCadPageState = useCADPageStore(useShallow((state) => state.setState))

  const { isLoading, data: cadData } = useCADQuery()
  const gltf = cadData.gltf

  if (isLoading || !gltf) return null

  return (
    <DropdownMenuItem>
      <ControlButton
        icon={<ResetIcon className="w-4 h-4" />}
        title="Reset"
        onClick={() => {
          gltf.showExplosionLines(explosions, false)
          gltf.resetExplosions(explosions)
          setCadPageState({
            explosions: {},
            loadedExplosion: '',
            isEditModeActive: false,
            explosionsState: ExplosionsState.DISABLED,
          })
        }}
      />
    </DropdownMenuItem>
  )
}
